import {
  FETCH_WALLET_BALANCE_ERROR,
  FETCH_WALLET_BALANCE_LOADING,
  FETCH_WALLET_BALANCE_SUCCESS,
  SET_WALLET_CURRENCY
} from '../ActionTypes';
import { IWalletBalance } from 'interfaces';

export const fetchWalletBalanceLoading = () => {
  return {
    type: FETCH_WALLET_BALANCE_LOADING
  };
};

export const fetchWalletBalanceError = (error: string) => {
  return {
    type: FETCH_WALLET_BALANCE_ERROR,
    payload: error
  };
};

export const fetchWalletBalanceSuccess = (data: IWalletBalance) => {
  return {
    type: FETCH_WALLET_BALANCE_SUCCESS,
    payload: data
  };
};

export const setWalletCurrency = (currency: string) => ({
  type: SET_WALLET_CURRENCY,
  payload: currency
});
